import * as React from 'react';
import classNames from 'classnames';
import { transition } from '@topconagriculture/theme';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        display: 'flex',
        position: 'relative',
        height: 30,
        cursor: 'pointer',
        borderRadius: 40,
        backgroundColor: theme.color.grey.lightest,
        boxShadow: theme.common.shadow.default,
        transition: transition(300, 'all', 'ease'),
    },
    rootDisabled: {
        boxShadow: 'none',
        pointerEvents: 'none',
        cursor: 'inherit',
        color: theme.color.grey.default,
        '& $switcher': {
            backgroundColor: theme.color.grey.default,
        },
    },
    switcher: {
        position: 'absolute',
        width: ({ count }) => `${100 / count}%`,
        height: '100%',
        borderRadius: '40px',
        backgroundColor: theme.color.primary.main,
        left: ({ index, count }) => `${(index / count) * 100}%`,
        transition: transition(300, 'all', 'ease'),
    },
    textContainer: {
        display: 'flex',
        alignItems: 'center',
        flexBasis: '100%',
        position: 'relative',
        float: 'left',
        textAlign: 'center',
    },
    text: {
        width: '100%',
        fontSize: theme.font.size.mediumSmall,
        transition: transition(400, 'color'),
    },
    textActive: {
        color: theme.color.font.light,
    },
}));
const SegmentedControl = (props) => {
    const { config, disabled, testId = 'SegmentedControl', onChange, value: selected } = props;
    const index = config.findIndex((option) => option.key === selected);
    const classes = useStyles({ count: config.length, index });
    const getClass = (key) => classNames(classes.text, {
        [classes.textActive]: key === selected,
    });
    return (React.createElement("div", { className: classNames(classes.root, { [classes.rootDisabled]: disabled }), "data-testid": `${testId}` },
        React.createElement("div", { "data-testid": `${testId}-value`, className: classes.switcher }),
        config.map((option) => (React.createElement("div", { className: classes.textContainer, onClick: () => onChange(option.key) },
            React.createElement("span", { "data-testid": `${testId}-${option.key}`, className: getClass(option.key) }, option.label))))));
};
export default SegmentedControl;
//# sourceMappingURL=SegmentedControl.js.map